// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
export const ReadyToGoRingLinkFragmentDoc = gql`
    fragment readyToGoRingLink on CatalogueReadyToGoRing {
  __typename
  slug
  primaryMetal {
    systemCode
  }
}
    `;